import { render, staticRenderFns } from "./horarios_colaboradores.vue?vue&type=template&id=5086eed1&scoped=true&"
import script from "./horarios_colaboradores.vue?vue&type=script&lang=js&"
export * from "./horarios_colaboradores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5086eed1",
  null
  
)

export default component.exports